module.exports = __webpack_public_path__ + "static/banner-moc-1-1-011adca3a42ab4e8803aa9ac93c6c36e.png";